
import axios from 'axios';
import { PrestazioneList, Prestazione, PrestazioneCreateCommand, PrestazioneUpdateCommand, IdVersion, PrestazioneDashboard, PrestazioneUpdateStatusCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/prestazioni';

export const getList = async (statusId: string): Promise<PrestazioneList[]> => {
    return (await axios.get(`${baseUrl}?statusId=${statusId ? statusId : ''}`)).data;
};

export const getDashboard = async (): Promise<PrestazioneDashboard[]> => {
    return (await axios.get(`${baseUrl}/dashboard`)).data;
};

export const getByKey = async (id: number): Promise<Prestazione> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const create = async (command: PrestazioneCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: PrestazioneUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const updateStatus = async (command: PrestazioneUpdateStatusCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update-status`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};
